(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("backtop", [], factory);
	else if(typeof exports === 'object')
		exports["backtop"] = factory();
	else
		root["backtop"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 